import INVENTORY_API_BASE_URL from "./config/api";
import "./config/apiClient";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ProSidebarProvider } from "react-pro-sidebar";
import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAccessToken } from "./config/apiClient";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";

import "@aws-amplify/ui-react/styles.css"; 

Amplify.configure(awsExports);

const authLink = setContext(async (_, { headers }) => ({
  headers: {
    ...headers,
    authorization: `Bearer ${await getAccessToken()}`,
  },
}));

const client = new ApolloClient({
  link: authLink.concat(
    createHttpLink({ uri: `${INVENTORY_API_BASE_URL}/graphql` })
  ),
  cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ProSidebarProvider>
        <App />
      </ProSidebarProvider>
    </ApolloProvider>
  </React.StrictMode>
);

reportWebVitals();
